module.exports = __webpack_public_path__ + "static/media/3.Hedge Trimmer.c59ef022.jpg";